export const PAY_METHOD = [
  { label: '现金', value: 'cash' },
  { label: '信用卡', value: 'creditCard' },
  { label: '第三方', value: 'others' },
];

export const CATEGORY = [
  {
    label: '吃喝',
    value: 'meal',
    icon: 'md-restaurant_menu',
  },
  {
    label: '交通',
    value: 'transport',
    icon: 'md-directions_transit_filled',
  },
  {
    label: '门票',
    value: 'ticker',
    icon: 'md-temple_buddhist',
  },
  {
    label: '购物',
    value: 'shopping',
    icon: 'md-shopping_bag',
  },
  {
    label: '活动',
    value: 'activity',
    icon: 'md-local_activity',
  },
  {
    label: '其他',
    value: 'others',
    icon: 'md-document_scanner',
  },
  {
    label: '机票',
    value: 'airplaneTicket',
    icon: 'md-airplane_ticket',
  },
  {
    label: '租车',
    value: 'carRental',
    icon: 'md-car_rental',
  },
  {
    label: '酒店',
    value: 'hotel',
    icon: 'md-hotel',
  },
  {
    label: '设备',
    value: 'devices',
    icon: 'md-devices_other',
  },

  {
    label: '保险',
    value: 'insurance',
    icon: 'md-health_and_safety',
  },
];
